/*
 *  谈单--后台配置
 * */

import request, { METHODS } from '@/api'
import UrlConfig, { getEnumURL } from '@/api/UrlConfigs'
/*
 *   空间类型管理--分页列表
 * */

export const fetchDealkingLifeSpaceList = ({ current, pageSize, data }) => {
  return request(UrlConfig.Deal.DealkingLifeSpaceSearchPage, {
    method: METHODS.POST,
    data,
    params: {
      pageId: current,
      pageSize,
    },
  })
}

/*
 *   空间类型 -- 列表 -- 用于下拉  /deal-web/dealkingLifeSpace/search/list
 * */
export const fetchDealkingLifeSpacePageList = (data = {}) => {
  return request(UrlConfig.Deal.DealkingLifeSpaceSearchList, {
    method: METHODS.POST,
    data,
  })
}

/*
 *    空间类型  -- 新增
 * */
export const addDealkingLifeSpace = data => {
  return request(UrlConfig.Deal.DealkingLifeSpace, {
    method: METHODS.POST,
    data,
  })
}

/*
 *    空间类型  -- 编辑  /deal-web/dealkingLifeSpace/updateById
 * */
export const editDealkingLifeSpace = data => {
  return request(UrlConfig.Deal.DealkingLifeSpaceUpdateById, {
    method: METHODS.POST,
    data,
  })
}

/*
 *    空间类型  -- 删除  /deal-web/dealkingLifeSpace/{id}
 * */
export const delDealkingLifeSpace = id => {
  return request(`${UrlConfig.Deal.DealkingLifeSpace}/${id}`, {
    method: METHODS.DELETE,
  })
}

/*
 *  生活场景管理 -- 分页列表
 * */
export const fetchDealkingLifeSceneList = ({ current, pageSize, data }) => {
  return request(UrlConfig.Deal.DealkingLifeSceneSearchPage, {
    method: METHODS.POST,
    data,
    params: {
      pageId: current,
      pageSize,
    },
  })
}

/*
 *    生活场景管理  -- 新增
 * */
export const addDealkingLifeScene = data => {
  return request(UrlConfig.Deal.DealkingLifeScene, {
    method: METHODS.POST,
    data,
  })
}

/*
 *    生活场景管理  -- 编辑
 * */
export const editDealkingLifeScene = data => {
  return request(UrlConfig.Deal.DealkingLifeSceneUpdateById, {
    method: METHODS.POST,
    data,
  })
}

/*
 *    生活场景管理  -- 删除
 * */
export const delDealkingLifeScene = id => {
  return request(`${UrlConfig.Deal.DealkingLifeScene}/${id}`, {
    method: METHODS.DELETE,
  })
}

/*
 *  场馆二维码 -- 分页
 * */
export const fetchDealkingVenueQrCode = ({ current, pageSize, data }) => {
  return request(UrlConfig.Deal.DealkingVenueQrCodeSearchPage, {
    method: METHODS.POST,
    data,
    params: {
      pageId: current,
      pageSize,
    },
  })
}

/*
 * 场馆二维码 -- 删除
 * */
export const delDdealkingVenueQrCode = id => {
  return request(`${UrlConfig.Deal.DealkingVenueQrCode}${id}`, {
    method: METHODS.DELETE,
  })
}

/*
 *   场馆二维码 -- 编辑
 * */
export const editDealkingVenueQrCode = data => {
  return request(UrlConfig.Deal.DealkingVenueQrCodeUpdateById, {
    method: METHODS.POST,
    data,
  })
}

/*
 *  展厅分类 -- 用于下拉
 * */
export const fetchDealkingVenueQrCodeList = () => {
  return request(UrlConfig.Deal.DealkingVenueQrCodeSearchList, {
    method: METHODS.POST,
    data: {},
  })
}

/*
 *   物料列表
 * */
// export const selectMaterialPage = ({current, pageSize, data}) => {
//   return sviRequest(`${UrlConfig.SviMpms.MaterielManageSkuSelectMaterialPage}?current=${current}&pageSize=${pageSize}`, {
//     method: METHODS.POST,
//     data
//   })
// }

/*
 *  谈单首頁配置 -- 分页
 * */
export const fetchDealkingTalkOrderHomeConf = ({ current, pageSize, data }) => {
  return request(UrlConfig.Deal.DealkingTalkOrderHomeConfSearchPage, {
    method: METHODS.POST,
    data,
    params: {
      pageId: current,
      pageSize,
    },
  })
}

/*
 *  谈单首頁配置 -- 查询是否拥有业务权限
 * */
export const fetchDealkingTalkHasBusPower = data => {
  return request(UrlConfig.Deal.DealkingTalkOrderHomeConfHasBusPower, {
    method: METHODS.POST,
    data,
  })
}

/*
 *  谈单首頁配置 -- 分页
 * */
export const fetchDealkingTalkOrderHomeConfList = ({ current, pageSize, data }) => {
  return request(UrlConfig.Deal.DealkingTalkOrderHomeConfSearchList, {
    method: METHODS.POST,
    data,
    params: {
      pageId: current,
      pageSize,
    },
  })
}

/*
 * 谈单首页配置 -- 删除
 * */
export const delDealkingTalkOrderHomeConf = id => {
  return request(`${UrlConfig.Deal.DealTalkOrderHomeConfDelHomeConfById}/${id}`, {
    method: METHODS.DELETE,
  })
}

/*
 *    谈单首页配置  -- 编辑
 * */
export const editDealkingTalkOrderHomeConf = data => {
  return request(UrlConfig.Deal.DealkingTalkOrderHomeConfUpdateById, {
    method: METHODS.POST,
    data,
  })
}

/*
 *    谈单首页配置 -- 二级菜单  -- 查询子级菜单树
 * */
export const getHomeConfigTree = data => {
  return request(UrlConfig.Deal.GetHomeConfigTree, {
    method: METHODS.POST,
    data,
  })
}

/*
 *  谈单首页配置 -- 二级菜单 -- 分页
 * */
export const getHomeConfigTreePagee = ({ current, pageSize, data }) => {
  return request(UrlConfig.Deal.GetHomeConfigTreePagee, {
    method: METHODS.POST,
    data,
    params: {
      pageId: current,
      pageSize,
    },
  })
}

/*
 *    谈单首页配置 -- 二级菜单  -- 编辑或新增
 * */
export const saveOrUpdateFirstMenu = data => {
  return request(UrlConfig.Deal.DealkingTalkOrderHomeConfSaveOrUpdateFirstMenu, {
    method: METHODS.POST,
    data,
  })
}

/*
 *    谈单首页配置  -- 新增
 * */
export const addDealkingTalkOrderHomeConf = data => {
  return request(UrlConfig.Deal.DealkingTalkOrderHomeConf, {
    method: METHODS.POST,
    data,
  })
}

/*
 *  广告列表 -- 分页
 * */
export const fetchDealkingTalkOrderHomeConfDtl = ({ current, pageSize, data }) => {
  return request(UrlConfig.Deal.DealkingTalkOrderHomeConfDtlSearchPage, {
    method: METHODS.POST,
    data,
    params: {
      pageId: current,
      pageSize,
    },
  })
}
/*
 *  广告列表 -- 分页
 * */
export const fetchDealkingTalkOrderHomeConfDtlList = ({ current, pageSize, data }) => {
  return request(UrlConfig.Deal.DealkingTalkOrderHomeConfDtlSearchList, {
    method: METHODS.POST,
    data,
    params: {
      pageId: current,
      pageSize,
    },
  })
}

/*
 * 广告列表 -- 删除
 * */
export const delDealkingTalkOrderHomeConfDtl = id => {
  return request(`${UrlConfig.Deal.DealkingTalkOrderHomeConfDtl}/${id}`, {
    method: METHODS.DELETE,
  })
}

/*
 *  -- 广告列表批量删除
 * */
export const talkOrderHomeConfDtlBatchDeleteByIds = data => {
  return request(UrlConfig.Deal.TalkOrderHomeConfDtlBatchDeleteByIds, {
    method: METHODS.POST,
    data,
  })
}

/*
 *    广告列表  -- 编辑
 * */
export const editDealkingTalkOrderHomeConfDtl = data => {
  return request(UrlConfig.Deal.DealkingTalkOrderHomeConfDtlUpdateById, {
    method: METHODS.POST,
    data,
  })
}

/*
 *    广告列表  -- 新增
 * */
export const addDealkingTalkOrderHomeConfDtl = data => {
  return request(UrlConfig.Deal.DealkingTalkOrderHomeConfDtl, {
    method: METHODS.POST,
    data,
  })
}

/*
 *    广告列表  -- 保存、新增
 * */
export const addOrEditeDealkingTalkOrderHomeConfDtl = data => {
  return request(UrlConfig.Deal.InsertOrUpdateOhcDtlVo, {
    method: METHODS.POST,
    data,
  })
}

/*
 *    广告列表  -- 批量新增
 * */
export const addMultipleDealkingTalkOrderHomeConfDtl = data => {
  return request(UrlConfig.Deal.BatchInsertOhcDtlVo, {
    method: METHODS.POST,
    data,
  })
}

/*
 *    枚举  -- 获取文件类型
 * */
export const getDataDictionaries = ({ path }: any = {}) => {
  return request(getEnumURL('deal', path), {
    method: METHODS.GET,
  })
}

/**
 * 组织销售产品配置 查询分页列表
 * @param data - body参数
 * @returns
 */
export const httpOrgSaleProductList = (data: any) => {
  return request(UrlConfig.Config.GetOrgSaleProductTree, {
    method: METHODS.POST,
    data,
  })
}

/**
 * 获取产品列表
 * @param data - body参数
 * @param params - query参数
 * @returns
 */
export const httpProdList = (data: any, params: any) => {
  return request(`/config-web/orgSaleProduct/searchPage`, {
    method: METHODS.POST,
    data,
    params,
  })
}

/**
 * 批量新增-组织与产品关系
 * @param data - body参数
 * @returns
 */
export const httpBatchAddOrgSaleProduct = (data: any) => {
  return request(UrlConfig.Config.OrgSaleProductBatchAddOrgSaleProduct, {
    method: METHODS.POST,
    data,
  })
}

/*
 *  角色产品配置列表
 * */
export const dealKingRoleSaleProductList = ({ current, pageSize, data }) => {
  return request(UrlConfig.Deal.DealKingRoleSaleProductList, {
    method: 'POST',
    data,
    params: {
      pageId: current,
      pageSize,
    },
  })
}

/*
 * 角色产品配置 -- 删除
 * */
export const delRoleSaleProductById = (id: string) => {
  return request(UrlConfig.Deal.DelRoleSaleProductById + id, {
    method: METHODS.DELETE,
  })
}

/*
 *  角色产品配置 -- 新增编辑
 * */
export const saveRoleSaleProduct = (data: any) => {
  return request(UrlConfig.Deal.SaveRoleSaleProduct, {
    method: METHODS.POST,
    data,
  })
}

/*
 *  获取角色列表
 * */
export const getRoleList = (data: any = {}) => {
  return request(UrlConfig.Caas.GetRoleList, {
    method: METHODS.POST,
    data,
  })
}

/*
 *  获取价格模板列表
 * */
// export const getPriceTemplateList = (data?:any) => {
//   return sviRequest(UrlConfig.SviMpms.FindPriceTemplate, {
//     method: METHODS.POST,
//     data,
//   })
// }

/*
 *  DreamHome -- 楼盘方案列表
 * */
export const fetchDealkingBuildPlanList = ({ current, pageSize, data }) => {
  return request(UrlConfig.Deal.GetDealkingBuildPlanList, {
    method: METHODS.POST,
    data,
    params: {
      pageId: current,
      pageSize,
    },
  })
}

/*
 *  DreamHome -- 楼盘方案新增
 * */
export const addDealkingBuildPlan = data => {
  return request(UrlConfig.Deal.AddOrDeleteDealkingBuildPlan, {
    method: METHODS.POST,
    data,
  })
}

/*
 *  DreamHome -- 楼盘方案删除
 * */
export const deleteDealkingBuildPlan = data => {
  return request(UrlConfig.Deal.AddOrDeleteDealkingBuildPlan, {
    method: METHODS.DELETE,
    data,
  })
}

/*
 *  DreamHome -- 楼盘方案配置编辑
 * */
export const updateDealkingBuildPlan = data => {
  return request(UrlConfig.Deal.UpdateDealkingBuildPlan, {
    method: METHODS.POST,
    data,
  })
}

/*
 *  DreamHome -- 楼盘方案配置列表
 * */
export const fetchBuildPlanConfList = ({ current, pageSize, data }) => {
  return request(UrlConfig.Deal.GetBuildPlanConfList1, {
    method: METHODS.POST,
    data,
    params: {
      pageId: current,
      pageSize,
    },
  })
}

/*
 *  DreamHome -- 楼盘方案配置编辑
 * */
export const updateDBuildPlanConf = data => {
  return request(UrlConfig.Deal.UpdateDBuildPlanConf1, {
    method: METHODS.POST,
    data,
  })
}

/*
 *  DreamHome -- 楼盘方案配置新增
 * */
export const addBuildPlanConf = data => {
  return request(UrlConfig.Deal.AddOrDeleteBuildPlanConf1, {
    method: METHODS.POST,
    data,
  })
}

/*
 *  DreamHome -- 楼盘方案配置删除
 * */
export const deleteBuildPlanConf = data => {
  return request(UrlConfig.Deal.AddOrDeleteBuildPlanConf1, {
    method: METHODS.DELETE,
    data,
  })
}
/**
 * 军种权限 - 获取军种, 数据字典
 */
export const getDictByParentKey = ({ parentKey, enabled = true }) => {
  return request(UrlConfig.Caas.GetDictService, {
    method: METHODS.POST,
    data: {
      parentKey,
      enabled,
    },
  })
}
